import styled from 'styled-components';
import React from 'react';
import { Checkbox, Heading } from '@alefeducation/ui-elements-library-core';
import CategoryCheckBoxGroup from './CategoryCheckBoxGroup';
import { usePermissionCategoryContext } from '../PermissionCategoryContext';
import Loading from '../../../Loading';
import { PERMISSION_NOT_FOUND, PERMISSIONS } from '../../../../utils/constants';

const StyledContainer = styled.div`
  margin: 0 40px;
  border: 1px solid #d1d6dd;
  border-radius: 8px;
`;

const StyledList = styled.div`
  overflow: auto;
  height: 40vh;
`;

const StyledSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d1d6dd;
`;

const StyledTotalPermissionCheckbox = styled.div`
  padding: 16px 0 0 16px;
`;

const StyledNoSearchResult = styled(StyledList)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PermissionCategoryList = () => {
  const {
    permissionCategories,
    totalPermissions,
    toggleAllPermissions,
    searchedText,
    isLoading,
  } = usePermissionCategoryContext();
  const totalCategories = permissionCategories.length;
  const totalPermissionText = `${PERMISSIONS} (${totalPermissions})`;

  return (
    <StyledContainer>
      {totalCategories === 0 && (
        <StyledNoSearchResult>
          {isLoading && <Loading />}
          {!isLoading && (
            <Heading variant="heading-small" weight="light" color="primary.100">
              {`${PERMISSION_NOT_FOUND} ${searchedText.trim()}`}
            </Heading>
          )}
        </StyledNoSearchResult>
      )}
      {totalCategories > 0 && (
        <React.Fragment>
          <StyledTotalPermissionCheckbox>
            <Checkbox
              variant="default"
              data-testid="total_permissions"
              id={totalPermissionText}
              value={totalPermissionText}
              aria-label={totalPermissionText}
              checked={permissionCategories.every((cp) => cp.isChecked)}
              onChange={() => {
                toggleAllPermissions();
              }}
            >
              {totalPermissionText}
            </Checkbox>
          </StyledTotalPermissionCheckbox>
          <StyledList>
            {permissionCategories.map((pc, i) => (
              <React.Fragment key={i}>
                <CategoryCheckBoxGroup category={pc} />
                {i + 1 !== totalCategories && <StyledSeparator />}
              </React.Fragment>
            ))}
          </StyledList>
        </React.Fragment>
      )}
    </StyledContainer>
  );
};

export default PermissionCategoryList;
